interface CustomWindow extends Window {
  AlgoSigner?: any
}

const customWindow:CustomWindow = window;
customWindow.AlgoSigner = customWindow.AlgoSigner || undefined
const AlgoSigner = customWindow.AlgoSigner; 

export default AlgoSigner;

